import React from 'react'
import Dropzone from '@adsk/alloy-react-dropzone'
import { type FileUploaderComponentProps } from './types'

const FileUploaderComponent: React.FC<FileUploaderComponentProps> = (
	props: FileUploaderComponentProps
): JSX.Element | null => {
	const {
		containerSize = 'small',
		size,
		accept,
		noDrag,
		hidden,
		onDrop,
		maxFiles,
		multiple,
		description,
		hideIllustration,
		illustration,
		title,
		customComponent,
		...additionalProps
	} = props
	const DragAndDropComponent = ({
		open,
	}: {
		open: () => void
	}): JSX.Element => {
		switch (containerSize) {
			case 'small':
				return (
					<Dropzone.ContentSmall
						open={open}
						title={title ?? ' '}
						linkText={customComponent}
						data-testid={'dragAndDropSmallContentTestId'}
					/>
				)
			case 'default':
			default:
				return (
					<Dropzone.Content
						open={open}
						title={title ?? 'Drag and drop an image file'}
						description={description ?? ''}
						linkText={customComponent ?? 'Choose image file'}
						data-testid={'dragAndDropTestId'}
						hideIllustration={hideIllustration ?? false}
						illustrationType={
							illustration ??
							Dropzone.Content.ILLUSTRATION_TYPES.PEOPLE_HEADS_GREY
						}
					/>
				)
		}
	}

	const renderContent = (open: () => void): JSX.Element => {
		return <DragAndDropComponent open={open} />
	}
	return hidden !== true ? (
		<Dropzone
			noDrag={noDrag ?? false}
			maxFiles={maxFiles ?? 1}
			size={size ?? Dropzone.SIZES.SMALL}
			multiple={multiple ?? false}
			renderContent={renderContent}
			onDrop={onDrop}
			onFileDialogCancel={function noRefCheck() {}}
			accept={accept}
			{...additionalProps}
		/>
	) : null
}

export default FileUploaderComponent
